import React, { useEffect } from 'react';
import { Switch, Route, useRouteMatch, useLocation } from 'react-router-dom';

import KYCJourney from '../../screens/KYC/index';
import KYCPending from '../../screens/KYC/KYCPending';
import { storeKycReturnUrl } from '../../screens/Oauth/kycReturn';

const KYCRoutes = () => {
  const { path } = useRouteMatch();
  const { search } = useLocation();

  // Captured here rather than in a screen because the backend can drop the
  // user on either /kyc or /kyc/pending, and the journey navigates away from
  // the query string before it finishes.
  useEffect(() => {
    storeKycReturnUrl(new URLSearchParams(search).get('returnUrl'));
  }, [search]);

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <KYCJourney />
      </Route>
      <Route exact path={`${path}/pending`}>
        <KYCPending />
      </Route>
    </Switch>
  );
};

export default KYCRoutes;
